export const TODO_NOTE_BOARD_SELECTION_EVENT = 'cp:todo-note-board-selection';

export type TodoNoteBoardSelectionDetail = {
  noteWorkspaceId: string | null;
  boardId: string;
  source: 'dashboard' | 'todo-note';
};

export function emitTodoNoteBoardSelection(detail: TodoNoteBoardSelectionDetail): void {
  if (typeof window === 'undefined') return;
  if (!detail.boardId.trim()) return;
  window.dispatchEvent(new CustomEvent(TODO_NOTE_BOARD_SELECTION_EVENT, { detail }));
}
